import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { InputTextModule } from "@openng/optimus-ui/inputtext";
import { AuthService } from "../../../services/api/auth/auth.service";
import { Router } from "@angular/router";
import { CheckboxModule } from "@openng/optimus-ui/checkbox";
import { LangSwitchComponent } from "../../../shared/components/lang-switch/lang-switch.component";
import { first } from "rxjs";
import { EMAIL_PATTERN } from "../../../constants/regExp";

@Component({
  standalone: true,
  selector: "app-user-activation",
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ButtonComponent,
    InputTextModule,
    CheckboxModule,
    LangSwitchComponent,
  ],
  templateUrl: "./user-activation.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./user-activation.component.scss",
})
export class UserActivationComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  public form = new FormGroup({
    username: new FormControl(null, [Validators.required, Validators.pattern(EMAIL_PATTERN)]),
  });

  /**
   * Handles Enter key press event. If pressed, calls {@link activate} method.
   * @param event KeyboardEvent
   */
  public onKeyUp(event: KeyboardEvent): void {
    if (event.key === "Enter") {
      this.activate();
    }
  }

  /**
   * Activates the user with the provided username. If the form is valid and the
   * username is provided, calls `AuthService.userActivation` method with the
   * username and navigates to the OTP page on success. Otherwise displays an
   * error message.
   */
  public activate(): void {
    const username = this.form.get("username")?.value;
    if (this.form.valid && username) {
      this.auth
        .userActivation(username)
        .pipe(first())
        .subscribe({
          next: (res) => {
            if (res) {
              this.router.navigateByUrl("/otp");
            }
          },
        });
    }
  }
}
